export var isChannelConference = function (channel) {
    return !!(channel === null || channel === void 0 ? void 0 : channel.is_conference);
};
